import { queryDidDocument } from '@trustvc/w3c-issuer';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const checkDidWebResolve = /* @__PURE__ */ __name(async (did, documentLoader) => {
  try {
    if (documentLoader) {
      return !!(await documentLoader(did)).document;
    }
    const { wellKnownDid } = await queryDidDocument({ did });
    if (!wellKnownDid) {
      throw new Error(`Failed to resolve DID: ${did}`);
    }
    return true;
  } catch {
    return false;
  }
}, "checkDidWebResolve");
const w3cIssuerIdentity = {
  skip: /* @__PURE__ */ __name(async () => {
    return {
      type: "ISSUER_IDENTITY",
      name: "W3CIssuerIdentity",
      reason: {
        code: 0,
        codeString: "SKIPPED",
        message: `Document has no issuer field.`
      },
      status: "SKIPPED"
    };
  }, "skip"),
  test: /* @__PURE__ */ __name((document) => {
    const doc = document;
    return Boolean(doc.issuer);
  }, "test"),
  verify: /* @__PURE__ */ __name(async (document, verifierOptions) => {
    const doc = document;
    if (doc.proof?.verificationMethod?.split("#")[0] !== doc.issuer) {
      return {
        type: "ISSUER_IDENTITY",
        name: "W3CIssuerIdentity",
        data: false,
        reason: {
          message: `Issuer and verification method do not match.`
        },
        status: "INVALID"
      };
    }
    const resolutionResult = await checkDidWebResolve(doc.issuer, verifierOptions?.documentLoader);
    if (resolutionResult) {
      return {
        type: "ISSUER_IDENTITY",
        name: "W3CIssuerIdentity",
        data: true,
        status: "VALID"
      };
    } else {
      return {
        type: "ISSUER_IDENTITY",
        name: "W3CIssuerIdentity",
        data: false,
        reason: {
          message: `The DID cannot be resolved.`
        },
        status: "INVALID"
      };
    }
  }, "verify")
};

export { w3cIssuerIdentity };
